export const subjects = {
  General: 'General',
  RequestForQuote: 'Request for Quote',
  ExpediteRequest: 'Expedite Request',
  LaserEngraving: 'Laser Engraving',
  SealAssembly: 'Seal Assembly',
  OrderStatusInquiry: 'Order Status Inquiry',
  NewAccountSetup: 'New Account Setup'
}
